exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content[data-v-6a104c38] {\n  background: #ccc;\n  height: 100%;\n  padding: 0.104167rem;\n}\n.content div[data-v-6a104c38] {\n  margin-bottom: 0.104167rem;\n  white-space: pre-wrap;\n}\n.click-pointer[data-v-6a104c38] {\n  text-decoration: underline;\n  color: rgb(65, 138, 179);\n  font-weight: bolder;\n  cursor: pointer;\n}", ""]);

// exports
